import * as React from "react"
import {
  Button,
  Icon,
  Label,
  Grid,
  Image,
  Message,
  Modal,
} from "semantic-ui-react"

import { IFileInfos } from "../../../core/actions"
import { IFileDetails, ISupplierReference } from "../../../models"
import { isError } from "../../../utils"
import { deleteDoublonComplex } from "../../../utils/doublon-tools"
import {
  IChangeFilePositionPayload,
  IDeleteFilePayload,
} from "../../product-form/_actions"
import {
  ICreateField,
  IFieldState,
} from "../../product-form/_reducers/_utils/product-form-types"

export interface IFileContainerFieldProps {
  code: string
  files: IFieldState<IFileDetails[]>
  error: string
  onDeleteFile: (props: IDeleteFilePayload) => void
  onChangeFilePosition: (props: IChangeFilePositionPayload) => void
}

class FileContainer extends React.Component<IFileContainerFieldProps> {
  // The reducer returns a new list on every file change: comparing references avoids serializing the files on
  // every render (FE-PERF-F05).
  public shouldComponentUpdate(nextProps: IFileContainerFieldProps) {
    return (
      this.props.files.value !== nextProps.files.value ||
      this.props.error !== nextProps.error
    )
  }

  public render() {
    const { files, onDeleteFile, onChangeFilePosition, code, error } =
      this.props
    return (
      <div className="grid-list-picture grid-list-file">
        <Grid columns={1} style={{ height: "100%", overflow: "auto" }}>
          {getFileDisplay(files, code, onDeleteFile, onChangeFilePosition)}
        </Grid>
        {error ? (
          <Message
            className="error-field-message error-textarea-message"
            negative
            header={error}
          />
        ) : (
          ""
        )}
      </div>
    )
  }
}

const getFileDisplay = (
  files: IFieldState<IFileDetails[]>,
  code: string,
  onDeleteFile: (props: IDeleteFilePayload) => void,
  onChangeFilePosition: (props: IChangeFilePositionPayload) => void
) => {
  const handleDeleteFile =
    (tile: any) =>
    (e: React.SyntheticEvent): void => {
      e.preventDefault()
      e.stopPropagation()
      onDeleteFile({ code, fileInfos: tile })
    }
  const handleChangeFilePosition =
    (tile: any, increment: boolean) =>
    (e: React.SyntheticEvent): void => {
      e.preventDefault()
      e.stopPropagation()
      onChangeFilePosition({ code, fileName: tile.file.name, increment })
    }

  return files.value.length < 1
    ? null
    : files.value.map((tile: IFileDetails) => (
        <Pdf
          name={tile.file.name}
          code={code}
          src={tile.blob}
          handleChangeFilePositionUp={handleChangeFilePosition(tile, true)}
          handleChangeFilePositionDown={handleChangeFilePosition(tile, false)}
          handleDeleteFile={handleDeleteFile(tile)}
          key={tile.file.name}
        />
      ))
}

export const FilePreviousVersion = (
  date: string,
  previousVersion: ISupplierReference
) => {
  return (
    <Modal
      style={{ width: 610 }}
      trigger={
        <Message
          className="previous-files"
          info
          content={
            <span>
              <b>
                {new Date(date).toLocaleDateString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}{" "}
                {" : "}
                {previousVersion?.pdf?.length}
              </b>{" "}
              <Icon name="file" />
            </span>
          }
        />
      }
      content={
        <div className="grid-list-picture grid-list-file previous">
          <Grid columns={1} style={{ height: "100%", overflow: "auto" }}>
            {deleteDoublonComplex(previousVersion.pdf, "name").map((p, i) => (
              <Pdf name={p.name} code={p.name} src={p.path} key={p.name} />
            ))}
          </Grid>
        </div>
      }
    />
  )
}

interface IPdfProps {
  name: string
  src: any | string
  code: string
  handleDeleteFile?: (e: React.SyntheticEvent) => void
  handleChangeFilePositionUp?: (e: React.SyntheticEvent) => void
  handleChangeFilePositionDown?: (e: React.SyntheticEvent) => void
}
const Pdf = ({
  name,
  src,
  code,
  handleChangeFilePositionUp,
  handleChangeFilePositionDown,
  handleDeleteFile,
}: IPdfProps) => {
  const download = () => window.open(src, "_blank")
  const className = "file-tile pdf-tile"

  return (
    <Image key={name} title={name} className={className}>
      <div className="file-controller-div">
        <div className="file-label-div-buttons">
          <Button
            name={code}
            type="button"
            className="file-button file-button-delete"
            onClick={handleDeleteFile}
            disabled={!handleDeleteFile}
          >
            <Icon name="trash" className="file-button-icon" />
          </Button>
          <Button
            name={code}
            type="button"
            className="file-button"
            onClick={handleChangeFilePositionUp}
            disabled={!handleChangeFilePositionUp}
          >
            <Icon name="chevron up" className="file-button-icon" />
          </Button>
          <Button
            name={code}
            type="button"
            className="file-button"
            onClick={handleChangeFilePositionDown}
            disabled={!handleChangeFilePositionDown}
          >
            <Icon name="chevron down" className="file-button-icon" />
          </Button>
        </div>
        <div className="file-label-div-label">
          <Label className="file-label">{name}</Label>
          <Button
            name={code}
            type="button"
            className="file-button" // download-button"
            onClick={download}
          >
            <Icon name="download" className="file-button-icon" />
          </Button>
        </div>
      </div>
    </Image>
  )
}

export default FileContainer
